<template>
  <div class="query">
    <Filters type="search" :filters="filters" toggleLabel="Search" :addDefault="true" v-on:save="search"/>
  </div>
</template>
<script>
  // Components
  import Filters from '../../common/Filters.vue';

	export default {
    components: {
      Filters
    },
    computed: {
      filters () {
        return this.$store.state.advancedSearch.filters
      }
    },
    methods: {
      search(filters) {
        this.$store.dispatch('advancedSearch/launch', {filters});
        // Redirect to result page while loading
        this.$router.push({ name: 'LibraryAdvancedSearchResults' });
      }
    }
	}
</script>
